import { clickReducer } from './clickReducer';
import { filterReducer } from './filterReducer';
import { optionsCapacidadeReducer } from './capacidadeReducer';
import { loadingReducer } from './loadingReducer';
import { toasterReducer } from './toasterReducer';
import { progressLoadingReducer } from './progressLoadingReducer';
import { dataPvReducer } from './dataPvReducer';
import { filterColunasPlanejamento } from './planejamentoFiltersReducer';
import { versaoReducer } from './versaoReducer';
import { modoOperacaoReducer } from './modoOperacaoReducer';
import { intervaloReducer } from './intervaloReducer';

import { combineReducers } from 'redux';

export const Reducers = combineReducers({
    clickState: clickReducer,
    filterState: filterReducer,
    capacidadeState: optionsCapacidadeReducer,
    toasterState: toasterReducer,
    loadingState: loadingReducer,
    progressLoadingState: progressLoadingReducer,
    dataPvState: dataPvReducer,
    filterColunasPlanejamento: filterColunasPlanejamento,
    versaoState: versaoReducer,
    modoOperacaoState: modoOperacaoReducer,
    intervaloState: intervaloReducer,
});
